export default __webpack_public_path__ + "a5e2b9f4c1d928b658572ce5e3a42e93.svg";